
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import useAccount from "@/composables/useAccount";
import { defineComponent, onMounted, ref } from "vue";
import AccountInformation from "./AccountInformation.vue";
import AccountPassword from "./AccountPassword.vue";
import AccountPreferences from "./AccountPreferences.vue";
import CustomerDetails from "./CustomerDetails.vue";
import { UserType } from "@/models/enums"

export default defineComponent({
	components: {
		AccountInformation,
		CustomerDetails,
		AccountPassword,
		AccountPreferences,
		BaseSpinner,
	},
	props: {
		isAgent: Boolean
	},
	setup() {
		const { getUser } = useAccount();
		const loading = ref(true);
		const user = ref({});

		onMounted(() => {
			getUser()
				.then((resp) => {
					user.value = resp;
				})
				.finally(() => (loading.value = false));
		});

		return { loading, UserType, user };
	},
});
